import React, { useState } from 'react';

export const UpdatePrompt = ({ registration }) => {
    const [isUpdating, setIsUpdating] = useState(false);

    if (!registration || !registration.waiting) {
        return null;
    }

    // --- FUNGSI HANDLEUPDATE YANG DIPERBARUI ---
    const handleUpdate = () => {
        setIsUpdating(true);
        // Kirim pesan ke SW yang menunggu untuk mengaktifkan dirinya
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });

        // Beri jeda singkat (misal, 500ms) untuk memastikan pesan terkirim
        // dan SW mulai proses aktivasi, lalu paksa reload halaman.
        // Ini jauh lebih bisa diandalkan daripada listener 'controllerchange'.
        setTimeout(() => {
            window.location.reload();
        }, 500);
    };

    return (
        <div className="fixed inset-0 z-[99999] bg-black bg-opacity-60 flex items-center justify-center backdrop-blur-sm p-4 animate-fade-in-fast">
            <div className="bg-white p-8 rounded-2xl shadow-xl max-w-sm w-full mx-auto text-center">
                <h3 className="text-xl font-bold text-slate-800">
                    {/* <Dialog.Title> */}
                    Pembaruan Tersedia
                    {/* </Dialog.Title> */}
                </h3>
                <p className="text-slate-600 my-4">
                    Versi baru dari aplikasi telah diunduh. Muat ulang untuk mendapatkan fitur dan perbaikan terbaru.
                </p>
                <button
                    onClick={handleUpdate}
                    disabled={isUpdating}
                    className="w-full px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg shadow-md hover:bg-orange-600 transition-colors disabled:bg-slate-400"
                >
                    {isUpdating ? 'Memuat ulang...' : 'Muat Ulang & Perbarui'}
                </button>
            </div>
        </div>
    );
};